<template>
	<div class="eb-card eb-news">
		<EbHeading level="h2" class="box-heading">Actualités du site maine-et-loire.fr</EbHeading>
		<div v-if="loading" class="flex justify-center align-items-center">
			<EbLoader></EbLoader>
		</div>
		<div v-else class="eb-news-list">
			<ul>
				<li v-for="item in actus">
					<a :href="item.url" class="eb-news-item" target="_blank" rel="noreferrer noopener" :title="item.title + ' - Nouvelle fenêtre'">
						<img :src="item.image" alt="" />
						<EbHeading level="h3">{{ item.title }} <font-awesome-icon :icon="['fas', 'external-link-alt']"/></EbHeading>
					</a>
				</li>
			</ul>
		</div>

		<EbHeading level="h2" class="box-heading">Réglementations du site maine-et-loire.fr</EbHeading>
		<div v-if="loading" class="flex justify-center align-items-center">
			<EbLoader></EbLoader>
		</div>
		<div v-else class="eb-news-list">
			<ul>
				<li v-for="item in reglement">
					<a :href="item.url" class="eb-news-item" target="_blank" rel="noreferrer noopener" :title="item.title + ' - Nouvelle fenêtre'">
						<!--<img :src="item.image">-->
						<EbHeading level="h3">{{ item.title }} <font-awesome-icon :icon="['fas', 'external-link-alt']"/></EbHeading>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
  name: 'actualitiesReglementation',
	data() {
		return {
			actus: null,
			reglement: null,
			loading: true,
		}
	},
	mounted() {
		this.getActus()
		this.getReglement()
	},
	methods: {
		getActus: async function() {
      await this.$http.get('rss/enfanceEtFamille')
      .then(resp => {
        this.actus = resp.data.listeActusRss,
        this.loading = false
			})
		},
		getReglement: async function() {
      await this.$http.get('rss/reglementationAssmat')
      .then(resp => {
        this.reglement = resp.data.listeActusRss,
        this.loading = false
			})
    }
  }
}
</script>

<style scoped>
ul {
	padding-left: 0;
}
li {
	list-style: none;
	margin-bottom: 32px;
}
</style>
